import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import * as fr from "@/src/common/locales/fr";

const resources = {
	fr,
};

export const LANGUAGES = {
	fr: "Français",
} as const;

export type Language = keyof typeof LANGUAGES;

export const NAMESPACES = {
	common: "common",
	auth: "auth",
	owner: "owner",
	tenant: "tenant",
	public: "public",
};

export type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = "fr";
export const DEFAULT_NAMESPACE: Namespace = "common";

use(initReactI18next).init({
	resources,
	ns: Object.values(NAMESPACES),
	defaultNS: DEFAULT_NAMESPACE,
	fallbackNS: DEFAULT_NAMESPACE,
	fallbackLng: DEFAULT_LANGUAGE,
	supportedLngs: Object.keys(LANGUAGES),
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: true,
	},
	nsSeparator: ":",
	keySeparator: ".",
	detection: {
		order: ["cookie", "navigator"],
		lookupCookie: "app-locale",
		caches: ["cookie"],
	},
});

export { default } from "i18next";
